'use strict';

import angular from 'angular';
import template from './modal.pug';

/**
 * TODO:
 *  - Prevent selection of groups already in membership
 */

const MemberModalSvc = [
  'ModalSvc',
  'LoaderSvc',
  'DatetimeSvc',
  'GroupSvc',
  'GrpTypeSvc',
  'MemTypeSvc',
  'MemberSvc',
  function(
    ModalSvc,
    LoaderSvc,
    DatetimeSvc,
    GroupSvc,
    GrpTypeSvc,
    MemTypeSvc,
    MemberSvc
  ) {
    /**
     * Opens the member Modal
     * @param  {Object} currentMembership
     * @param  {string} groupId
     * @param  {string} personId
     * @return {Object}
     */
    function open(currentMembership, groupId, personId) {
      var membership = angular.copy(currentMembership);
      var modalvm = {unsavedUpdates: false};
      var modalInstance;

      //////////////////////////////////////////////////////////////////////////
      // Get Member Types for Option List
      //////////////////////////////////////////////////////////////////////////
      var memberTypes = [];
      var memTypeHash = {};
      MemTypeSvc.getDefinedFor({groupId}).$promise
        .then(function(memTypes) {
          for(var i in memTypes) {
            var mt = memTypes[i];
            memberTypes.push(mt);
            memTypeHash[mt.id] = mt;
          }
          modalvm.memTypeHash = memTypeHash;
        });

      //////////////////////////////////////////////////////////////////////////
      ///  Pick Group to Edit
      //////////////////////////////////////////////////////////////////////////
      function setEditGroup(group) {
        // convert start/stop to local dates for form
        group.membership.map(DatetimeSvc.getFormDateRange);
        // set matching type for drop-down
        group.membership.map(function(m) {
          if(!m.type && m.typeId) {
            m.type = memTypeHash[m.typeId];
          }
          return m;
        });
        modalvm.editGroup = group;
        modalvm.editGroupId = group.group.id;
        modalvm.unsavedUpdates = true;
      }

      function updateGroup() {
        modalvm.submitted = true;
        if(modalvm.editformvm.$valid) {
          var editM = modalvm.editGroup.membership;
          for(var m = 0; m < editM.length; m++) {
            DatetimeSvc.setDatesBasedOnForm(editM[m]);
            if(!editM[m].id && !editM[m].start && !editM[m].end) {
              editM.splice(m, 1);
              m--;
              continue;
            }
            delete editM[m].startOpen;
            delete editM[m].endOpen;
          }
          delete modalvm.editGroup;
          delete modalvm.editGroupId;

          modalvm.submitted = false; //reset for other group edits
        }
      }

      //////////////////////////////////////////////////////////////////////////
      ///  Edit Group Active Periods
      //////////////////////////////////////////////////////////////////////////
      var editformvm;
      function changeStart(mem) {
        var formStart = new Date(mem.formStart);
        var formEnd;
        // reset end if start is updated
        if(mem.formEnd) { formEnd = new Date(mem.formEnd); }
        if(formEnd && formEnd < formStart) { mem.formEnd = null; }
      }

      function clearEnd(mem) {
        mem.formEnd = null;
        modalvm.editformvm.$setDirty();
      }

      function addPeriod(activePeriods) {
        activePeriods.push({});
      }

      function removePeriod(activePeriods, index) {
        if(!activePeriods[index].id) {
          activePeriods.splice(index, 1);
        } else {
          // mark for deletion
          activePeriods[index].delete = true;
        }

        modalvm.editformvm.$setDirty();
      }

      /**
       * AngularUI Datepicker
       * NOTE: can open multiple datepickers at a time
       */
      modalvm.dateFormat = 'M/d/yyyy';
      function openActive($event, mem, dateType) {
        $event.preventDefault();
        $event.stopPropagation();
        mem[dateType + 'Open'] = true;
      }

      //////////////////////////////////////////////////////////////////////////
      // Get Groups for Option List
      //////////////////////////////////////////////////////////////////////////
      var groupsByType = [];
      var typeHash = {}; // child: parent
      var groupSelect = {};

      GrpTypeSvc.getDesc({groupId}).$promise
        .then(function(types) {
          // Use Promise.all for parallel execution
          return Promise.all(types.map(function(type) {
            typeHash[type.id] = type;
            var params = {groupId, groupTypeId: type.id};
            return GroupSvc.query(params).$promise.then(function(groups) {
              type.groups = groups;
              groupsByType.push(type);
            });
          }));
        });

      function filterParent(gtid) {
        var type = typeHash[gtid];
        if(!type) { return; }
        var group = groupSelect[type.parentId];
        return group ? group.id : undefined;
      }

      //////////////////////////////////////////////////////////////////////////
      ///  Add Group
      //////////////////////////////////////////////////////////////////////////
      function showAddGroupForm() {
        modalvm.showAddGroup = true;
        modalvm.unsavedUpdates = true;
      }

      function cancelAddToGroup() {
        modalvm.showAddGroup = false;
      }

      function addToGroup() {
        modalvm.showAddGroup = false;
        // ignore parents in selection
        var newGroup;
        var ignoreParents = [];
        // find parents to ignore
        var g;
        for(var i in groupSelect) {
          g = groupSelect[i];
          if(g.parentId) { ignoreParents.push(g.parentId); }
        }
        // add groups
        for(var j in groupSelect) {
          g = groupSelect[j];
          if(ignoreParents.indexOf(g.id) === -1) {
            newGroup = {
              group: g,
              membership: [{ start: DatetimeSvc.getDatePropString() }]
            };
            membership.push(newGroup);
          }
        }
        if(!newGroup) { return; }
        setEditGroup(newGroup);
      }

      //////////////////////////////////////////////////////////////////////////
      ///  Submit Membership Updates
      //////////////////////////////////////////////////////////////////////////
      function getMemUpdates() {
        // organize all records
        var newMembership = [];
        var editMembership = [];
        var deleteMembership = [];
        for(var g in modalvm.membership) {
          var grp = modalvm.membership[g];
          for(var m = 0; m < grp.membership.length; m++) {
            var mem = grp.membership[m];

            // delete
            if(mem.delete && mem.id) {
              deleteMembership.push({group: {id: grp.group.id}, id: mem.id});
              // remove from array for page Updates
              grp.membership.splice(m, 1);
              m--;
              continue;
            }

            var memReq = {
              group: {id: grp.group.id},
              person: {id: personId},
              start: mem.start,
              end: mem.end,
              typeId: mem.typeId
            };

            // create
            if(!mem.id) {
              newMembership.push(memReq);
              continue;
            }

            // update
            // if start is not a string, membership was not selected for editing
            if(typeof mem.start !== 'string') { continue; }
            // compare to current membership - requires g and m to stay ordered
            var cur = currentMembership[g].membership[m];
            if(cur.start) {
              cur.start = DatetimeSvc.getDatePropString(cur.start);
            }
            cur.start = cur.start || null; // set undefined to null
            if(cur.end) {
              cur.end = DatetimeSvc.getDatePropString(cur.end, true);
            }
            cur.end = cur.end || null; // set undefined to null
            // compare types
            var curMemTypeId = cur.type && cur.typeId ? cur.typeId : null;

            if(mem.typeId !== curMemTypeId
              || mem.start !== cur.start || mem.end !== cur.end) {
              memReq.id = mem.id; // add id for update
              editMembership.push(memReq);
            }
          }
        }
        return {
          newMembership,
          editMembership,
          deleteMembership
        };
      }

      function processMemUpdates(memUpdates) {
        // Use native async/await for serial execution
        return (async function() {
          // create
          for(const newMem of memUpdates.newMembership) {
            await MemberSvc.save({groupId: newMem.group.id}, newMem).$promise;
          }
          // update
          for(const editMem of memUpdates.editMembership) {
            var params = {groupId: editMem.group.id, id: editMem.id};
            await MemberSvc.update(params, editMem).$promise;
          }
          // delete
          for(const delMem of memUpdates.deleteMembership) {
            var delParams = {groupId: delMem.group.id, id: delMem.id};
            await MemberSvc.delete(delParams).$promise;
          }
        }());
      }

      function onSubmit() {
        LoaderSvc.start();
        modalvm.submitted = true;
        if(!modalvm.unsavedUpdates) { modalInstance.close(); }

        if(modalvm.editGroup) { updateGroup(); }
        var memUpdates = getMemUpdates();
        processMemUpdates(memUpdates)
          .then(function() {
            angular.extend(currentMembership, membership);
            LoaderSvc.stopSuccess('Membership Groups Updated');
            modalInstance.close(modalvm.groups);
          })
          .catch(function(e) {
            LoaderSvc.stopError('System Error: ' + e);
          });
      }

      function onCancel() {
        modalInstance.dismiss();
      }

      //////////////////////////////////////////////////////////////////////////
      ///  Set Modal Scope
      //////////////////////////////////////////////////////////////////////////
      var modalScope = {modalvm: angular.extend(modalvm,
        {
          dismissable: true,
          membership, memberTypes,
          // edit groups
          setEditGroup, updateGroup, editformvm,
          changeStart, clearEnd, addPeriod, removePeriod, openActive,
          // add group
          showAddGroupForm, cancelAddToGroup, addToGroup,
          groupsByType, groupSelect, filterParent,
          // modal settings
          title: 'Edit Membership',
          buttons: [
            {
              classes: 'btn-primary',
              text: 'Update Membership',
              click: onSubmit
            },
            {classes: 'btn-default', text: 'Close', click: onCancel}
          ]
        })
      };

      var options = {size: 'lg', template};

      modalInstance = ModalSvc.open(modalScope, options);
      return modalInstance.result;
    }

    // Public API here
    return {
      open
    };
  }
];

export default MemberModalSvc;
